"use strict";

// Connecting vendors (plugins)
import "./_vendor";

// Functions
import { mobileCheck, swiperInit, formHandler, UTMParams } from "./functions/";

// Components
// import { formValidation } from "./components/";

window.addEventListener("DOMContentLoaded", () => {
  mobileCheck();
  swiperInit();
  formHandler();
  UTMParams();
});
